/**
 * Uppsägning av lokalhyresavtal för villkorsändring (12 kap. 58 § JB).
 *
 * One document, five automatically numbered points. The landlord signs the
 * uppsägning; the tenant(s) sign the erkännande of receipt. The medhyresgäst
 * panel appears only when a medhyresgäst is named.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
export const UPPSAGNING_LOKAL_PARTY_SLOTS = [
    { id: 'lessor', label: 'Hyresvärd', role: 'lessor', ordinal: 0, required: true, signs: true },
    { id: 'lessee_primary', label: 'Hyresgäst', role: 'lessee', ordinal: 0, required: true, signs: true },
    {
        id: 'lessee_co',
        label: 'Medhyresgäst',
        role: 'lessee',
        ordinal: 1,
        signs: true,
        help: 'Valfritt — lägg till om lokalavtalet har två hyresgäster.',
    },
];
export function uppsagningLokalComposition(variant, values) {
    const blocks = [
        {
            instanceId: 'letterhead',
            blockRef: 'common.letterhead@v1',
            slot: 'letterhead',
            input: { title: variant.title, form_number: variant.formNumber },
        },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: variant.formNumber } },
        { instanceId: 'rubrik', blockRef: `${variant.documentKey}.rubrik@v1`, input: {} },
        { instanceId: 'parter', blockRef: 'uppsagning_villkorsandring_lokal.parter@v1', input: {} },
        { instanceId: 'uppsagning', blockRef: 'uppsagning_villkorsandring_lokal.uppsagning@v1', input: {} },
        { instanceId: 'meddelande', blockRef: variant.meddelandeRef, input: {} },
        {
            instanceId: 'underskrift',
            blockRef: 'uppsagning_villkorsandring_lokal.underskrift@v1',
            input: {
                ref: 'underskrift',
                title: 'Underskrift (hyresvärd)',
                parties: [{ label: 'Hyresvärd', role: 'lessor', ordinal: 0 }],
            },
        },
        {
            instanceId: 'erkannande',
            blockRef: 'uppsagning_villkorsandring_lokal.underskrift@v1',
            input: {
                ref: 'erkannande',
                title: 'Erkännande (hyresgäst)',
                lead: variant.receipt,
                parties: [
                    { label: 'Hyresgäst', role: 'lessee', ordinal: 0 },
                    { label: 'Medhyresgäst', role: 'lessee', ordinal: 1, when_set: 'cotenant_name' },
                ],
            },
        },
    ];
    return {
        schema: COMPOSITION_SCHEMA,
        version: COMPOSITION_VERSION,
        documentKey: variant.documentKey,
        documentVersion: 'v1',
        title: variant.title,
        locale: 'sv-SE',
        meta: {
            ...variant.meta,
            category: 'Lokalhyra',
            numberStyle: 'paragraph',
            formNumber: variant.formNumber,
            signingMode: 'digital',
            status: 'active',
            titleSuffix: { key: 'contract_number', prefix: 'avtal' },
            connectedTo: ['lokalhyra'],
            inheritFromParent: {
                parties: 'by-role-ordinal',
                property: true,
                values: [{ key: 'contract_number', fromParentKey: 'contract_number' }],
            },
            signingPlacementAnchors: 'per-party-label',
            partySlots: UPPSAGNING_LOKAL_PARTY_SLOTS,
            propertySlots: [{ id: 'property', label: 'Fastighet', multi: false, required: true }],
        },
        values,
        blocks,
    };
}
export const uppsagningVillkorsandringLokalV1 = (values = {}) => uppsagningLokalComposition({
    documentKey: 'uppsagning_villkorsandring_lokal',
    title: 'Uppsägning av lokalhyresavtal för villkorsändring',
    formNumber: 'Formulär R-19',
    meddelandeRef: 'uppsagning_villkorsandring_lokal.meddelande@v1',
    receipt: 'Jag har denna dag tagit emot en med denna likalydande handling.',
    meta: {
        shortTitle: 'Uppsägning villkorsändring (lokal)',
        statute: '12 kap. 58 § jordabalken',
        preamble: 'Hyresvärdens uppsägning av lokalhyresavtalet för villkorsändring enligt 12 kap. jordabalken.',
        description: 'Hyresvärdens uppsägning av ett lokalhyresavtal för villkorsändring (12 kap. 58 § JB). Använd när hyresvärden vill ändra villkoren för en lokalhyresgäst och säger upp avtalet för omförhandling.\n\n' +
            'Vem undertecknar: hyresvärden (uppsägningen) och hyresgästen (erkännande om mottagande). Skickas via Scrive.\n\n' +
            'Hyresgästen har indirekt besittningsskydd: om förlängning inte kommer till stånd måste hyresgästen hänskjuta tvisten till hyresnämnden för medling inom två månader från uppsägningen, annars förloras rätten till ersättning enligt 12 kap. 58 b § JB.\n\n' +
            'Kopplad mall — skapas under det lokalhyresavtal som sägs upp. Parter, lokal och avtalsnummer förförifylls från lokalavtalet (även om det är ett importerat avtal).',
    },
}, values);
//# sourceMappingURL=uppsagning_villkorsandring_lokal.js.map